import {AfterViewInit, Component, Inject, OnInit, Renderer2} from "@angular/core";
import {NewsletterService} from "../../service/newsletter/newsletter.service";
import {Newsletter} from "../../service/newsletter/newsletter";
import {environment} from "../../../environments/environment";
import {DOCUMENT} from "@angular/platform-browser";

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss'],
  providers: [NewsletterService]
})
export class NewsletterComponent implements OnInit, AfterViewInit {

  en: boolean;

  constructor(private newsletterService: NewsletterService,
              private renderer2: Renderer2,
              @Inject(DOCUMENT) private _document) {
    this.en = environment.english;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://s3.ap-northeast-2.amazonaws.com/resource.stibee.com/subscribe/stb_subscribe_form.js';
    s.text = ``;
    this.renderer2.appendChild(this._document.body, s);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/newsletter/newsletter.component.ts